/* eslint-disable prefer-rest-params */
import { isUndefined } from 'lodash';
import axios from 'src/utils/axios';
import parse from 'src/utils/parse';

interface ChildCompaniesApiProps {
    parentId: string,
    page: number,
    pageSize: number,
    search: string
}

export interface GetListsApiProps {
    page: number,
    pageSize: number,
    search?: string,
    organizationId: string,
    column?: string,
    sort?: number
}

class CompaniesApi {
    async getChildCompaniesByParentId({
        parentId,
        page = 0,
        pageSize = 25,
        search = '' }: ChildCompaniesApiProps
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            axios.get(
                `${process.env.REACT_APP_CASES}/organization?page=${page}&pageSize=${pageSize}&parentId=${parentId}&search=${search}`
            )
                .then((response) => {
                    response = parse(response);
                    if (!isUndefined(response?.data)) {
                        resolve(response);
                    } else {
                        reject(new Error('internal Server Error'));
                    }
                })
                .catch(() => {
                    reject(new Error('internal Server Error'));
                });
        });
    }

    async getCompanyById(companyId: string): Promise<any> {
        return new Promise((resolve, reject) => {
            axios.get(
                `${process.env.REACT_APP_CASES}/organization/${companyId}`
            )
                .then((response) => {
                    response = parse(response);
                    if (!isUndefined(response?.data)) {
                        resolve(response);
                    } else {
                        reject(new Error('internal Server Error'));
                    }
                })
                .catch(() => {
                    reject(new Error('internal Server Error'));
                });
        });
    }

    async getCompanyOverviewById(companyId: string): Promise<any> {
        return new Promise((resolve, reject) => {
            axios.get(
                `${process.env.REACT_APP_CASES}/organization/${companyId}/overview`
            )
                .then((response) => {
                    response = parse(response);
                    if (!isUndefined(response?.data)) {
                        resolve(response);
                    } else {
                        reject(new Error('internal Server Error'));
                    }
                })
                .catch(() => {
                    reject(new Error('internal Server Error'));
                });
        });
    }

    async getCompanyProjects(params: GetListsApiProps): Promise<any> {
        return new Promise((resolve, reject) => {
            // Build query string from params object
            const queryParams = new URLSearchParams();
            Object.entries(params).forEach(([key, value]) => {
                if (value !== undefined && value !== null && value !== '') {
                    queryParams.append(key, String(value));
                }
            });

            axios.get(
                `${process.env.REACT_APP_CASES}/project?${queryParams.toString()}`
            )
                .then((response) => {
                    response = parse(response);
                    if (!isUndefined(response?.data)) {
                        resolve(response);
                    } else {
                        reject(new Error('internal Server Error'));
                    }
                })
                .catch(() => {
                    reject(new Error('internal Server Error'));
                });
        });
    }
}

export const companiesApi = new CompaniesApi();